<template>
    <v-card>
        <v-card-title class="justify-center">
            Cadastre as Redes Sociais do Seu Posto
        </v-card-title>
        <v-layout justify-space-around wrap full-width >
            <v-flex xs3>
                <v-select :items="['Email','Site', 'Telefone', 'Instagram', 'Facebook', 'Twitter', 'Linkedin', 'YouTube', 'Whatsapp','Telegram' ]"
                    v-model="rede_selecionada" />
            </v-flex>
            <v-flex xs6>
                <v-text-field v-model="link_perfil" label="Link do perfil" />
            </v-flex>
            <v-flex xs1>
                <v-btn fab small color="primary" class="mt-4" @click="cadastrarRedeSocial">
                    <v-icon>add</v-icon>
                </v-btn>
            </v-flex>
            <v-flex xs12  v-if="redesSociais.length > 0">
                <v-list style="padding-inline:5%;">
                    <v-list-item v-for="(redeSocial, index) in redesSociais" :key="index">
                        <v-layout>
                        <v-flex xs2>
                            <v-list-item-icon>
                            <img v-if="redeSocial.nome" style="width: 70%;"
                                :src="require(`@/assets/icons/${redeSocial.nome}.png`)" class="mr-2" />
                        </v-list-item-icon>
                        </v-flex>
                        <v-flex xs8>
                            <v-list-item-content>
                                <v-flex xs12>
                                    <v-list-item-title style="width: 80%;">
                                {{ redeSocial.nome }}
                            </v-list-item-title>
                                </v-flex>
                                <v-flex xs12>
                                    <v-list-item-subtitle style="width: 80%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;display: block;">
                                <a :href="redeSocial.link_perfil"
                                    style="text-decoration: none; color: gray;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                    {{ redeSocial.link_perfil }}
                                </a>
                            </v-list-item-subtitle>
                                </v-flex>
                            </v-list-item-content>
                        </v-flex>
                            <v-flex xs2>
                                <v-list-item-action style="width: 10%;">
                            <v-btn icon @click="deletarRedeSocial(redeSocial.id)">
                                <v-icon>close
                                </v-icon>
                            </v-btn>
                        </v-list-item-action>
                            </v-flex>
                        </v-layout>
                    </v-list-item>
                </v-list>
            </v-flex>
        </v-layout>
        <v-card-actions class="justify-space-around">
            <v-btn rounded class="mb-3" color="primary" @click="$emit('fechar')">
                Finalizar
            </v-btn>

        </v-card-actions>
    </v-card>
</template>

<script>
export default {
  props: ['posto'],
  data: () => ({
    rede_selecionada: 'Instagram',
    link_perfil: undefined,
    redesSociais: []
  }),
  methods: {
    pegarRedesSociais () {
      const data = { cnpj: this.posto.cnpj, method: 'GET' }
      this.$store.dispatch('redesSociais', data).then(json => {
        this.redesSociais = json
      })
    },
    cadastrarRedeSocial () {
      if (!this.link_perfil) this.$store.dispatch('setError', 'Você precisa preencher o campo link do perfil')
      const data = { cnpj: this.posto.cnpj, method: 'POST', nome: this.rede_selecionada, link_perfil: this.link_perfil }
      this.$store.dispatch('redesSociais', data).then(() => {
        this.pegarRedesSociais()
      })
    },
    deletarRedeSocial (idRede) {
      const data = { cnpj: this.posto.cnpj, method: 'DELETE', id_rede_social: idRede }
      this.$store.dispatch('redesSociais', data).then(() => {
        this.pegarRedesSociais()
      })
    }
  },
  beforeMount () {
    if (!this.posto) {
      this.$store.dispatch('setError', 'Empresa não encontrada')
      this.$emit('fechar')
    }
    this.pegarRedesSociais()
  }
}

</script>
